'use client';

import React from 'react';
import { useRouter } from 'next/navigation';
import styles from './DetailHeaderActions.module.scss';
import { EventDetail } from '@/sanity/fetchEventDetail';
import { ArticleDetail } from '@/sanity/fetchArticleDetail';
import ActionFavorite from '../action/favorite/ActionFavorite';

type BaseProps = {
  href: string;
};

type DetailHeaderProps =
  | (BaseProps & { eventId?: EventDetail['_id']; articleId?: never })
  | (BaseProps & { articleId?: ArticleDetail['_id']; eventId?: never })
  | (BaseProps & { eventId?: never; articleId?: never });

export default function DetailHeaderActions({
  href,
  eventId,
  articleId,
}: DetailHeaderProps) {
  const router = useRouter();
  const activeId = eventId || articleId;

  const handleClick = () => {
    const currentHostname = window.location.hostname;
    const referrer = document.referrer;
    let isInternalReferrer = false;
    if (referrer) {
      try {
        const refUrl = new URL(referrer);
        isInternalReferrer = refUrl.hostname === currentHostname;
      } catch {
        isInternalReferrer = false;
      }
    }
    // Check whether the referrer comes from our own site
    if (isInternalReferrer && window.history.length > 1) {
      router.back();
    } else {
      // Redirect to the home page when coming from an external site or with no referrer
      router.replace('/');
    }
  };

  return (
    <div className={styles.wrapper}>
      <button onClick={handleClick} aria-label="Zurück zur vorherigen Seite">
        <div className={styles.buttonContent}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            aria-hidden="true"
            focusable="false"
          >
            <path
              d="M15 8.25H5.8725L10.065 4.0575L9 3L3 9L9 15L10.0575 13.9425L5.8725 9.75H15V8.25Z"
              fill="black"
            />
          </svg>
          zurück
        </div>
      </button>

      <div>
        {activeId && (
          <ActionFavorite
            id={activeId}
            className={styles.favoriteButton}
            bookmarkType={eventId ? 'Event' : articleId ? 'Guide' : undefined}
            disableBackgroundColor={true}
          />
        )}
      </div>
    </div>
  );
}
